/**
 * Thousands-separator formatting for user-facing counts and totals (ENG-9684).
 *
 * Locale is pinned to `en-US`. A bare `toLocaleString()` follows the *browser*
 * locale, so a teacher on a de-DE browser would read "1.234" for one thousand
 * two hundred thirty-four. Same reasoning as the school-timezone rule in
 * CLAUDE.md: the product is US-English, and browser settings must not change
 * what a number means.
 *
 * Do NOT use this for:
 *   - Identifiers or codes (student/SIS IDs, access codes, badge barcodes,
 *     zip codes, school years). "1,234,567" is not a student ID.
 *   - Values written into CSV/export cells. A comma breaks the file in Excel.
 *     Format the surrounding prose (toasts, headers), never the cell.
 *   - Values bounded well under 1,000 by the domain (behavior point values,
 *     step counters, house counts). Formatting is a no-op there.
 *
 * Where a number lives in a fixed-width slot, prefer a compact formatter with
 * the exact value in a `title` (see `formatCompactPoints` in reports.timeline)
 * rather than forcing commas into a container that cannot grow.
 */
export function formatNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '0';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (!Number.isFinite(num)) return '0';
  return num.toLocaleString('en-US');
}
